import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Image, StatusBadge } from '@domain-group/suit-theme'

import useImage from '@hooks/useImage'

import { UseBulkSelectImagesPayload } from '@modals/BulkSelectImagesModal/hooks/useBulkSelectImages'

import type { ImageModel } from '@models/types'

import DeletedImageUrl from './assets/deleted-image.png'

const getBackgroundColor = (isSelected: boolean) => {
  if (isSelected) return 'rgba(0, 0, 0, 0.5)'
  return null
}

interface ThumbnailProps {
  callbacks: {
    selectImageId: UseBulkSelectImagesPayload['callbacks']['selectId'],
  },
  fullScreen: boolean,
  image: ImageModel,
  selectionIndex: number,
  viewMode: string,
}

const Thumbnail = (props: ThumbnailProps) => {
  const {
    callbacks: { selectImageId }, fullScreen, image, selectionIndex, viewMode,
  } = props

  const imagePayload = useImage(image)
  const {
    image: {
      id, id_code, original_url, thumb_url,
    },
    isPlan,
  } = imagePayload

  const isSelected = selectionIndex !== -1

  // If the image is a plan, use the original URL to preserve dimensions, otherwise use the thumbnail URL
  const imageUrl = isPlan ? original_url : thumb_url

  const height = viewMode === 'large' ? 200 : 110

  return (
    <Image
      // @ts-expect-error TS2322
      borderColor="lineColor"
      borderRadius={5}
      boxProps={{
        backgroundSize: isPlan ? 'contain' : 'cover',
        onClick: () => selectImageId(id),
      }}
      height={fullScreen ? undefined : height}
      style={fullScreen ? { aspectRatio: '4 / 3' } : undefined}
      url={imageUrl || DeletedImageUrl}
    >
      <Box
        alignItems="center"
        backgroundColor={getBackgroundColor(isSelected)}
        borderRadius={5}
        height="100%"
        justifyContent="center"
        position="relative"
        style={{ cursor: 'pointer' }}
      >
        {isSelected && (
          <Box
            alignItems="center"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            border="2px solid white"
            borderRadius="100%"
            color="white"
            height="40px"
            justifyContent="center"
            width="40px"
          >
            {thumb_url ? (selectionIndex + 1) : <FontAwesomeIcon icon={faTrashAlt} />}
          </Box>
        )}

        {id_code && (
          <StatusBadge
            boxProps={{
              position: 'absolute',
              top: 'medium',
              right: 'medium',
              width: 'auto',
            }}
            color="rgba(0, 0, 0, 0.8)"
            text={id_code}
          />
        )}
      </Box>
    </Image>
  )
}

export default Thumbnail
